export const validateRequired = (value: string | number | undefined | null): boolean => {
	if (typeof value === "number") {
		return !isNaN(value);
	}

	return value !== undefined && value !== null && value !== "";
};
